import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { api } from '../services/api'

interface Admin {
  id: string
  email: string
  name: string
}

interface AuthContextType {
  admin: Admin | null
  token: string | null
  isLoading: boolean
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  isAuthenticated: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [admin, setAdmin] = useState<Admin | null>(null)
  const [token, setToken] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    console.log('[AuthProvider] Inicializando...')
    
    const storedToken = localStorage.getItem('token')
    const storedAdmin = localStorage.getItem('admin_data')
    
    console.log('[AuthProvider] storedToken existe?', !!storedToken)
    console.log('[AuthProvider] storedAdmin existe?', !!storedAdmin)
    
    if (storedToken && storedAdmin) {
      console.log('[AuthProvider] Restaurando sessão')
      setToken(storedToken)
      try {
        setAdmin(JSON.parse(storedAdmin))
      } catch (e) {
        console.error('[AuthProvider] Erro ao parsear admin:', e)
        localStorage.removeItem('admin_data')
      }
    } else {
      console.log('[AuthProvider] Nenhuma sessão encontrada')
    }
    
    setIsLoading(false)
  }, [])

  const login = useCallback(async (email: string, password: string) => {
    console.log('[AuthProvider] Login iniciado para:', email)
    
    const response = await api.login(email, password)
    
    console.log('[AuthProvider] Login bem-sucedido')
    
    localStorage.setItem('token', response.token)
    localStorage.setItem('admin_data', JSON.stringify(response.admin))
    
    setToken(response.token)
    setAdmin(response.admin)
  }, [])

  const logout = useCallback(async () => {
    console.log('[AuthProvider] Logout iniciado')
    
    const currentToken = token || localStorage.getItem('token')
    
    if (currentToken) {
      try {
        await api.logout(currentToken)
      } catch (error) {
        console.error('[AuthProvider] Erro no logout:', error)
      }
    }
    
    localStorage.removeItem('token')
    localStorage.removeItem('admin_data')
    
    setToken(null)
    setAdmin(null)
  }, [token])

  const value = React.useMemo(() => ({
    admin,
    token,
    isLoading,
    login,
    logout,
    isAuthenticated: !!token && !!admin && !isLoading
  }), [admin, token, isLoading, login, logout])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}